import { SimpleVariantFragmentType } from 'types/Variant';

const checkIsConfigurable = (variant: SimpleVariantFragmentType) =>
  variant.product.isConfigurable && variant.product.baseConfigurationVariantId === variant.id;

export default checkIsConfigurable;
